import log from 'loglevel'
import { Button, Box, Card, CardContent, Grid, Typography } from '@mui/material'
import { Confirm, Form, useTranslate } from 'react-admin'
import React from 'react'
import { doExecute } from './functions'

log.setLevel(log.levels.DEBUG)

const ExecuteButton: React.FC<{ id: string }> = ({ id }) => {
  const translate = useTranslate()
  const [open, setOpen] = React.useState(false)
  const onClick = (): void => {
    setOpen(true)
  }
  const onClose = (): void => {
    setOpen(false)
  }
  const onConfirm = (): void => {
    setOpen(false)
    doExecute(id)
      .then((_status: number | undefined) => {})
      .catch(log.error)
  }
  return (
    <>
      <Button
        variant="contained"
        color="primary"
        size="large"
        sx={{ borderRadius: '10px', width: '150%' }}
        onClick={onClick}>
        <Typography variant="button">
          {translate('resources.cognito.execute.buttons.execute')}
        </Typography>
      </Button>
      <Confirm
        isOpen={open}
        title={'resources.cognito.execute.dialog.title'}
        content={'resources.cognito.execute.dialog.content'}
        onConfirm={onConfirm}
        onClose={onClose}
        cancel="resources.cognito.execute.dialog.cancel"
        confirm="resources.cognito.execute.dialog.confirm"
      />
    </>
  )
}

export const Cognito: React.FC<{ id: string }> = ({ id }) => {
  const translate = useTranslate()
  return (
    <Card raised sx={{ width: '1280px', marginBottom: '1em' }}>
      <CardContent>
        <Form>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center'
            }}>
            <Box sx={{ width: '1280px' }}>
              <Box
                sx={{
                  marginLeft: '0.5em',
                  marginRight: '0.5em'
                }}>
                <Grid
                  container
                  justifyContent="center"
                  alignItems="center"
                  spacing={0.5}
                  sx={{
                    marginTop: '0.1em'
                  }}>
                  <Grid item xs={7}>
                    <Typography>
                      {translate(`resources.cognito.execute.confirm`)}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <ExecuteButton id={id} />
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </Box>
        </Form>
      </CardContent>
    </Card>
  )
}
